export const GCAL = {
  UserPoolId: `${process.env['NX_COGNITO_USER_POOL_ID']}`,
  ClientId: `${process.env['NX_COGNITO_CLIENT_ID']}`,
  Endpoint: `${process.env['NX_COGNITO_ENDPOINT']}`,
};
export const PAGE_SIZE = process.env['NX_PAGE_SIZE'] as string;
export const ASSETS_API = process.env['NX_ASSETS_API'] as string;
export const ASSETS_CDN_URL = process.env['NX_ASSETS_CDN_URL'] as string;
export const COUNTLY_APP_KEY = process.env[
  'NX_EASYCLASS_COUNTLY_APP_KEY'
] as string;
export const COUNTLY_URL = process.env['NX_EASYCLASS_COUNTLY_URL'] as string;

export const CLOUDFLARE_IMAGE_PREFIX = process.env[
  'NX_CLOUDFLARE_IMAGE_PREFIX'
] as string;

export const NX_OPENPANEL_CLIENT_ID = process.env[
  'NX_OPENPANEL_CLIENT_ID'
] as string;

export const NX_OPENPANEL_API_URL = process.env[
  'NX_OPENPANEL_API_URL'
] as string;

export const NX_GRAPHQL_WS_URL = process.env['NX_GRAPHQL_WS_URL'] as string;

export const NX_BUNNY_LIBRARY_ID = process.env['NX_BUNNY_LIBRARY_ID'] as string;
export const NX_LRS_ENDPOINT = process.env['NX_LRS_ENDPOINT'] as string;
export const NX_LRS_KEY = process.env['NX_LRS_KEY'] as string;
export const NX_LRS_SECRET = process.env['NX_LRS_SECRET'] as string;
export const NX_DO_STORAGE = process.env['NX_DO_STORAGE'] as string;
